
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPencilBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.469 13.618a.625.625 0 0 1-.442-1.067l9.767-9.766a.625.625 0 1 1 .883.883l-9.766 9.767a.623.623 0 0 1-.442.183z",
  fill: "var(--theme-primary, #810ea9)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.506 18.118a.625.625 0 0 1-.612-.756l.967-4.5a.626.626 0 0 1 1.222.261l-.966 4.501a.625.625 0 0 1-.61.494zm4.498-.968a.625.625 0 0 1-.442-1.067l9.767-9.767a.625.625 0 0 1 .884.884l-9.767 9.766a.623.623 0 0 1-.442.183z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.505 18.114a.625.625 0 0 1-.13-1.236l4.5-.966a.626.626 0 0 1 .263 1.222l-4.501.966a.611.611 0 0 1-.132.014zM15.006 9.16c-.16 0-.32-.06-.442-.183L11.03 5.442a.625.625 0 0 1 .883-.884l3.536 3.535a.625.625 0 0 1-.442 1.067zm1.764-1.77a.625.625 0 0 1-.442-1.067c.348-.347.54-.818.54-1.325s-.192-.978-.54-1.326a1.858 1.858 0 0 0-1.326-.54c-.507 0-.978.192-1.325.54a.625.625 0 1 1-.885-.884 3.099 3.099 0 0 1 2.21-.905 3.1 3.1 0 0 1 2.21.905c.584.584.905 1.369.905 2.21s-.321 1.626-.905 2.21a.622.622 0 0 1-.442.183z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M3.469 13.618a.625.625 0 0 1-.442-1.067l9.767-9.766a.625.625 0 1 1 .883.883l-9.766 9.767a.623.623 0 0 1-.442.183z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M2.506 18.118a.625.625 0 0 1-.612-.756l.967-4.5a.626.626 0 0 1 1.222.261l-.966 4.501a.625.625 0 0 1-.61.494zM7.004 17.15a.625.625 0 0 1-.442-1.067l9.767-9.767a.625.625 0 0 1 .884.884l-9.767 9.766a.623.623 0 0 1-.442.183z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n    <path d=\"M2.505 18.114a.625.625 0 0 1-.13-1.236l4.5-.966a.626.626 0 0 1 .263 1.222l-4.501.966a.611.611 0 0 1-.132.014zM15.006 9.16c-.16 0-.32-.06-.442-.183L11.03 5.442a.625.625 0 0 1 .883-.884l3.536 3.535a.625.625 0 0 1-.442 1.067zM16.77 7.39a.625.625 0 0 1-.442-1.067c.348-.347.54-.818.54-1.325s-.192-.978-.54-1.326a1.858 1.858 0 0 0-1.326-.54c-.507 0-.978.192-1.325.54a.625.625 0 1 1-.885-.884 3.099 3.099 0 0 1 2.21-.905 3.1 3.1 0 0 1 2.21.905c.584.584.905 1.369.905 2.21s-.321 1.626-.905 2.21a.622.622 0 0 1-.442.183z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/pencil_big.70c027bd2b741e8a059369e2fa11b0c8.svg"),
        {
          React: SvgPencilBig,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      